import { PropsWithChildren, createContext, useContext, useMemo } from 'react'

import { useAuth } from '@app/auth/auth-context'
import { AdminApiClient, createAdminApiClient } from '@shared/api'

const ApiClientContext = createContext<AdminApiClient | null>(null)

export const ApiClientProvider = ({ children }: PropsWithChildren) => {
	const { getAccessToken } = useAuth()
	const client = useMemo(() => createAdminApiClient(getAccessToken), [getAccessToken])
	return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>
}

export const useAdminApi = () => {
	const client = useContext(ApiClientContext)
	if (!client) throw new Error('useAdminApi must be used inside ApiClientProvider')
	return client
}

export const useApiClient = useAdminApi
